import { render, staticRenderFns } from "./SimpleCategoryProducts/template.pug?vue&type=template&id=4fb52d07&lang=pug&"
import script from "./SimpleProductList.vue?vue&type=script&lang=js&"
export * from "./SimpleProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports